import React, { useRef, useState, useEffect, Suspense, startTransition } from 'react';
import classnames from 'classnames';

import { FilterContextProvider } from "./context/context";

import { updateFilterUrl } from './helpers/url';
import { filter_items } from './helpers/filters';

const Filters = React.lazy(() => import('./components/Filters'));
const FilterNav = React.lazy(() => import('./components/FilterNav'));
const FilterNavMobile = React.lazy(() => import('./components/FilterNavMobile'));
const TopFilter = React.lazy(() => import('./components/TopFilter'));
const ListView = React.lazy(() => import('./components/ListView'));
const FilterTotals = React.lazy(() => import('./components/FilterTotals'));


const FilterUI = props => {
  const {
    items,
    filterForm,
    topFilter,
    filterSettings,
    language
  } = props;


  const isInitialMount = useRef(true);

  const pagination = filterSettings.pagination;

  const allForms = [...filterForm, topFilter];
  const [filterNav, setFilterNav] = useState(allForms);
  const [totalItems, setTotalItems] = useState(props.items.length);
  const [filterView, setFilterView] = useState(filterSettings.currentView);
  const [activeFilters, setActiveFilters] = useState(filterSettings.activeFilters);
  const [activeFiltersNav, setActiveFiltersNav] = useState(filterSettings.activeFilters);

  const [allItems, setAllItems] = useState(items);
  const [filteredItems, setFilteredItems] = useState(items);
  const [currentPage, setCurrentPage] = useState(filterSettings.pagination.currentPage);
  const [dateRangeSelected, setDateRangeSelected] = useState(false);
  const [dateSelected, setDateSelected] = useState(new Date().setHours(0,0,0,0));
  const [navStatus, setNavStatus] = useState(false);
  const [datesMenuStatus, setDatesMenuStatus] = useState(false);
  const [datesMenuOther, setDatesMenuOther] = useState(true);

  const [inProp, setInProp] = useState(false);
  const [opacity, setOpacity] = useState(false);
  const [pagedItems, setPagedItems] = useState([]);





  const states = {activeFiltersNav, setActiveFiltersNav, pagedItems, setPagedItems, opacity, setOpacity, inProp, setInProp,datesMenuOther, setDatesMenuOther,  datesMenuStatus, setDatesMenuStatus, allItems, setAllItems, filterView, setFilterView, filterNav, setFilterNav, activeFilters, setActiveFilters, totalItems, setTotalItems, filteredItems, setFilteredItems, pagination, currentPage, setCurrentPage, dateRangeSelected, setDateRangeSelected, dateSelected, setDateSelected, language, navStatus, setNavStatus};

  const viewResults = () => {
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav);
    setNavStatus(false);
    const body = document.querySelector('body');
    body.classList.remove('filters-open');

    let container = document.querySelector('.filter-block'),
      pos = container.offsetTop;

      window.scrollTo(0, pos - 100)

  }

  const updateItems = () => {
    const results = filter_items(items, activeFilters, filterView);
    setTotalItems(results.length);
    setFilteredItems(results);
    let totalPageCount = Math.ceil(results.length / pagination.perpage);
    if (currentPage > totalPageCount ){
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }
    updateFilterUrl(activeFilters, currentPage, filterView);

  }

  const setItems = () => {
    const results = filter_items(items, activeFilters, filterView);
    setTotalItems(results.length);
    setFilteredItems(results);
  }


  const clearAllFilters = () => {
    const a = {...activeFilters};
    let es = document.getElementById("events-search");
    if (es) {
      es.value = '';
    }
    for (const key in a) {
      if (a[key].position !== "top"){
        if (typeof a[key].value == "object") {
          if (a[key].name == "calendar"){
            if (filterView == "list"){
              a[key].value = "";
            } else {
              a[key].value = [new Date(new Date().setHours(0,0,0,0)), new Date(new Date().setHours(0,0,0,0))];
            }
          } else {
            a[key].value = [];
            a[key].selectedTitles = [];
          }
        } else {
          a[key].value = "";
        }
      }
    }
    setDateRangeSelected(false);
    setActiveFilters(a);
  }


  const toggleFilterNav = (widget) => {
    const body = document.querySelector('body');
    let updatedFilterNav = [...filterNav];
    let any_filters_open = false;

    if (!widget){
       widget = updatedFilterNav[0];
       updatedFilterNav.map((nav, i) => {
         if (nav.open) {
           widget = nav;
         }
       })
    }

    const widget_id = widget.id;

    updatedFilterNav.map((nav, i) => {
      if (nav.id == widget.id){
        nav.open =  !widget.open;
      } else {
        nav.open = false;
      }
      if (nav.open) {
        any_filters_open = true;
      }
    })

    if (any_filters_open) {
      body.classList.add('filters-open');
      setNavStatus(true);
    } else {
      body.classList.remove('filters-open');
      setNavStatus(false);
    }

    setFilterNav(updatedFilterNav)
  }




  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      updateItems();
    }
  }, [activeFilters, currentPage]);

  useEffect(() => {
    setItems();
  }, [items]);

  return (
    <>

      <FilterContextProvider value={states}>
      <div className="block-filters-outer">
      <div className="container">
      <div className="block-filters-inner">
        <div
          className={classnames('filter-bg', {
            active: navStatus
          })}
          onClick={() => viewResults()}></div>

        <div
        className={classnames('block-filters-mobile', {
          active: navStatus
        })}
        >
          <FilterNavMobile topFilter={topFilter} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} />
          <div class="mobile-filter-panels">
            <Filters filterForm={filterForm}  toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters}/>
            <div
            className={classnames('mobile-filter-actions', {
              active: navStatus
            })}
            >
              <FilterTotals  />
              <div className="mobile-filter-actions-buttons">
                <button class="button button-black" onClick={viewResults}>See results</button>
                <button class="button button-white" onClick={clearAllFilters}>Clear all filters</button>
              </div>
            </div>
          </div>
        </div>

        <div

        id="drag_container"
        className={classnames('block-filters-desktop', {
          active: navStatus
        })}
        >
            <div className="filters">
              <div className="filter-nav-container">
                <FilterNav filterForm={filterForm} toggleFilterNav={toggleFilterNav} clearAllFilters={clearAllFilters} viewResults={viewResults}/>
              </div>
            </div>

            <Filters filterForm={filterForm}  clearAllFilters={clearAllFilters} viewResults={viewResults} />


        </div>

        <Suspense>
         <div className="block-filter-views">
              <TopFilter data={topFilter} />

             <div className="block-filter-views-inner">

              <ListView />

              </div>

          </div>

        </Suspense>
        </div>
        </div>
        </div>
      </FilterContextProvider>

    </>
  );
}
export default FilterUI;
